import { AlertTriangle, ArrowRight, Mail } from 'lucide-react'
import { UseFormReturn } from 'react-hook-form'
import { FormInput, FormWrapper } from 'src/shared/components/FormComponents'
import { Column, Row } from 'src/shared/components/Semantic/all'
import { Button } from 'src/shared/components/ui'
import { useLocalization } from 'src/shared/hooks/useLocalization'
import { AuthenticateFormData } from '../types'
import { isWorkEmail } from '../utils'

export const EmailForm = ({
  methods,
  onSubmit,
  loading,
  isCompanyUrlValid,
  isLoginMode,
  emailLabel,
  emailPlaceholder,
  submitLabel,
}: {
  methods: UseFormReturn<AuthenticateFormData>
  onSubmit: (data: AuthenticateFormData) => void
  loading: boolean
  isCompanyUrlValid: boolean
  isLoginMode: boolean
  emailLabel?: string
  emailPlaceholder?: string
  submitLabel?: string
}) => {
  const { t } = useLocalization()
  const watchedEmail = methods.watch('email')
  const isValidWorkEmail = watchedEmail && isWorkEmail(watchedEmail)

  return (
    <FormWrapper methods={methods} onSubmit={onSubmit}>
      <Column className="gap-3">
        <FormInput
          name="email"
          methods={methods}
          className="w-full"
          type="email"
          label={
            emailLabel ??
            t('Professional email address', 'Professionell e-postadress')
          }
          placeholder={
            emailPlaceholder ??
            t(
              'Work email (e.g., alfred@spotify.com)',
              'Arbetsmejl (t.ex., alfred@spotify.com)'
            )
          }
          startContent={<Mail className="h-4 w-4 text-muted-foreground" />}
        />

        {watchedEmail && !isWorkEmail(watchedEmail) && (
          <Row className="card-inner items-center gap-2 p-3 text-sm text-amber-700">
            <AlertTriangle className="h-4 w-4 shrink-0" />
            <span>
              {t(
                'This email appears to be a personal email. Please use a work email address instead.',
                'Denna e-post verkar vara en personlig e-post. Använd en arbetsmejladress istället.'
              )}
            </span>
          </Row>
        )}

        <Button
          type="submit"
          disabled={
            loading ||
            !isValidWorkEmail ||
            (!isLoginMode && !isCompanyUrlValid)
          }
          id="analyze-brand"
          variant="primary"
          className="mt-1 w-full"
          size="lg"
          isLoading={loading}
        >
          {submitLabel ??
            (isLoginMode
              ? t('Log in', 'Logga in')
              : t('Sign up', 'Registrera dig'))}

          <ArrowRight className="ml-2 h-4 w-4" />
        </Button>
      </Column>
    </FormWrapper>
  )
}
